import { get, remove, set } from 'lib/storage/versionedLocalStorageUtils'
import { toUtmParams } from 'lib/url/utmCodesUtils'
import config from 'constants/config'

// Redux state
// Increment version when we change the state structure in an incompatible way.
const REDUX_CART_STATE_KEY = 'checkoutCartReduxState'
const REDUX_CART_STATE_VERSION = 15

const REDUX_FORM_STATE_KEY = 'checkoutFormReduxState'
const REDUX_FORM_STATE_VERSION = 7

const REDUX_PAYMENT_STATE_KEY = 'checkoutPaymentReduxState'
const REDUX_PAYMENT_STATE_VERSION = 8

export function saveCheckoutReduxPaymentState(state: App.Checkout.PaymentState) {
  set(REDUX_PAYMENT_STATE_KEY, REDUX_PAYMENT_STATE_VERSION, state)
}

export function getSavedCheckoutReduxPaymentState(): App.Checkout.PaymentState | null {
  return get(REDUX_PAYMENT_STATE_KEY, REDUX_PAYMENT_STATE_VERSION)
}

export function saveCheckoutReduxCartState(state: App.CheckoutCartState) {
  set<{ state: App.CheckoutCartState, timestamp: number }>(REDUX_CART_STATE_KEY, REDUX_CART_STATE_VERSION, { state, timestamp: Date.now() })
}

export function getSavedCheckoutReduxCartState() {
  return get<{ state: App.SavedCheckoutReduxCartState, timestamp: number }>(REDUX_CART_STATE_KEY, REDUX_CART_STATE_VERSION)
}

export function clearSavedCheckoutReduxCartState() {
  remove(REDUX_CART_STATE_KEY)
}

export function saveCheckoutReduxFormState(
  cartId: string,
  formState: App.Checkout.FormState,
  formSchema: App.Checkout.TravellerFormSchemaData | undefined,
  memberId: string | undefined,
) {
  set(REDUX_FORM_STATE_KEY, REDUX_FORM_STATE_VERSION, { cartId, formState, formSchema, memberId, timestamp: Date.now() })
}

interface SavedCheckoutReduxFormState {
  cartId: string
  formState: App.Checkout.FormState
  formSchema: App.Checkout.TravellerFormSchemaData | undefined
  memberId: string | undefined
  timestamp: number
}

export function getSavedCheckoutReduxFormState(): SavedCheckoutReduxFormState | null {
  return get(REDUX_FORM_STATE_KEY, REDUX_FORM_STATE_VERSION)
}

export function clearSavedCheckoutReduxFormState() {
  remove(REDUX_FORM_STATE_KEY)
}

/**
 * svc-cart still expects UTM params
 *
 * @remarks
 * Customer portal no longer uses it, so we keep this implementation isolated to where still need it
 */
export function getUtmParams(utm: App.UTMState) {
  return {
    utm_source: config.BRAND,
    utm_medium: 'web',
    ...toUtmParams(utm),
  }
}
